import script from "./ManagedServices.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagedServices.vue?vue&type=script&setup=true&lang=js"

import "./ManagedServices.vue?vue&type=style&index=0&id=de25db30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de25db30"]])

export default __exports__